import React from 'react';
import Body from '@redturtle/iovisit-theme/components/Blocks/CountDown/Body';

const View = ({ data }) => {
  return <Body data={data} />;
};

export default View;
